import { ModalCustom } from "components/ModalCustom";
import { Icone, ModalBody } from "./style";
import { FaExclamation } from "react-icons/fa";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirm: () => void;
}

export function ModalCertezaEditarVeiculo({
  show,
  handleClose,
  onConfirm,
}: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Editar veículo"
      centered={true}
      footer={true}
      footerConfirmButton={true}
      onConfirm={onConfirm}
      confirmButtonText="Salvar"
    >
      <ModalBody>
        <Icone>
          <FaExclamation />
        </Icone>
        Deseja salvar as alterações realizadas no veículo?
      </ModalBody>
    </ModalCustom>
  );
}
